import * as Yup from 'yup';

export const ToggleDashboardModeSchema = Yup.object().shape({
    mode: Yup.string().required('Mode is required'),
});

export interface ToggleDashboardModeDataType {
    mode: string;
}

export const ToggleDashboardModeInitialValues: ToggleDashboardModeDataType = {
    mode: 'Dev Mode',
};


export interface ToggleDashboardModeDataInterface {
    isTestMode: boolean;
}
